export default (locale) => {
  switch (locale) {
    case 'az':
      return import(/* webpackChunkName: "i18n.common.az" */'./common.az');
    case 'bn':
      return import(/* webpackChunkName: "i18n.common.bn" */'./common.bn');
    case 'es':
      return import(/* webpackChunkName: "i18n.common.es" */'./common.es');
    case 'fr':
      return import(/* webpackChunkName: "i18n.common.fr" */'./common.fr');
    case 'hr':
    case 'bs':
      return import(/* webpackChunkName: "i18n.common.hr" */'./common.hr');
    case 'kk':
      return import(/* webpackChunkName: "i18n.common.kk" */'./common.kk');
    case 'pt':
    case 'pt-br':
      return import(/* webpackChunkName: "i18n.common.pt" */'./common.pt');
    case 'ro':
      return import(/* webpackChunkName: "i18n.common.ro" */'./common.ro');
    case 'ru':
      return import(/* webpackChunkName: "i18n.common.ru" */'./common.ru');
    case 'sr':
    case 'sr-latn':
    case 'sr-Latn':
      return import(/* webpackChunkName: "i18n.common.sr-Latn" */'./common.sr-Latn');
    case 'uz':
      return import(/* webpackChunkName: "i18n.common.uz" */'./common.uz');
    case 'tr':
      return import(/* webpackChunkName: "i18n.common.uz" */'./common.tr');
    default:
      return import(/* webpackChunkName: "i18n.common" */'./common');
  }
};
